export default "__VITE_ASSET__Bdb8JNsA__"